var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-grid",class:{pen: _vm.loading}},[(_vm.loading)?_vm._l((_vm.placeholders),function(i,k){return _c('product-card',{key:k})}):_vm._l((_vm.records),function(i,k){return _c('product-card',{key:k,attrs:{"data":i,"type":_vm.type,"productCardType":_vm.productCardType,"trackProps":_vm.getTrackProps(k)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }